import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'utils/axios';

// GET ALL SCHEDULE PRICE
export const getAllSchedulePrice = createAsyncThunk(
  'schedulePrice/getAllSchedulePrice',
  async ({ page = 1, type = 1 }, thunkAPI) => {
    // type 1 = schedule price daily
    // type 2 = schedule price airport transfer

    try {
      const response = await axiosInstance.get(`/schedule-price?page=${page}&limit=10&type_id=${type}`);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

// GET SCHEDULE PRICE BY ID
export const getDetailSchedulePrice = createAsyncThunk('schedulePrice/getDetailSchedulePrice', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.get(`/schedule-price/${id}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

// CREATE SCHEDULE PRICE
export const createSchedulePrice = createAsyncThunk('schedulePrice/createSchedulePrice', async (payload, thunkAPI) => {
  try {
    const response = await axiosInstance.post(
      `/schedule-price`,
      { ...payload },
      {
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
      },
    );

    const data = await response.data;
    return data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

// UPDATE SCHEDULE PRICE
export const updateSchedulePrice = createAsyncThunk('schedulePrice/updateSchedulePrice', async (payload, thunkAPI) => {
  const { payloadData, schedulePriceId } = payload;

  try {
    const response = await axiosInstance.put(
      `/schedule-price/${schedulePriceId}`,
      { ...payloadData },
      {
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
      },
    );

    const data = await response.data;
    return data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

// DELETE SCHEDULE PRICE
export const deleteSchedulePrice = createAsyncThunk('schedulePrice/deleteSchedulePrice', async (id, thunkAPI) => {
  try {
    const response = await axiosInstance.delete(`/schedule-price/${id}`);

    return response.data;
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response.data);
  }
});

// GET ALL SCHEDULE PRICE VALUE
export const getAllSchedulePriceValue = createAsyncThunk(
  'schedulePriceValue/getAllSchedulePriceValue',
  async (page = 1, thunkAPI) => {
    try {
      const response = await axiosInstance.get(`/schedule-price-value?page=${page}&limit=10`);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

// CREATE SCHEDULE PRICE VALUE
export const createSchedulePriceValue = createAsyncThunk(
  'schedulePriceValue/createSchedulePriceValue',
  async (payload, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        `/schedule-price-value`,
        { ...payload },
        {
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
          },
        },
      );

      const data = await response.data;
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

// UPDATE SCHEDULE PRICE VALUE
export const updateSchedulePriceValue = createAsyncThunk(
  'schedulePriceValue/updateSchedulePriceValue',
  async (payload, thunkAPI) => {
    const { payloadData, schedulePriceValueId } = payload;

    try {
      const response = await axiosInstance.put(
        `/schedule-price-value/${schedulePriceValueId}`,
        { ...payloadData },
        {
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
          },
        },
      );

      const data = await response.data;
      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);

// DELETE SCHEDULE PRICE
export const deleteSchedulePriceValue = createAsyncThunk(
  'schedulePriceValue/deleteSchedulePriceValue',
  async (id, thunkAPI) => {
    try {
      const response = await axiosInstance.delete(`/schedule-price-value/${id}`);

      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response.data);
    }
  },
);
